export enum FrequencyTriggerRangeEnum {
    "day" = "day",
    "week" = "week",
    "month" = "month",
    "shift" = "shift",
}
export interface IRCASetting {
    downtimeType: string;
    durationTrigger: {
        duration: number;
        enabled: boolean;
    };
    frequencyTrigger: {
        frequency: number;
        enabled: boolean;
        frequencyRange: FrequencyTriggerRangeEnum;
    };
    owner: string | number | null;
}

export interface IRCASettings {
    mill: {
        mill_id: number;
        name: string;
    };
    rcaSettings: IRCASetting[];
}

export enum ModuleSettingsEnum {
    RCA_TRIGGERS = 1,
    MEETING_TYPES = 2,
}
